module.exports = __webpack_public_path__ + "files/SOS Workshop 2 Templates.528264bd.pdf";